export default __webpack_public_path__ + "static/media/09_motor_Agencias.2fe77471.svg";